module.exports = __webpack_public_path__ + "static/media/geronimo_rulli.2547f748.jpg";